<style>
.ag-theme-material .ag-cell {
    line-height: 35px !important;
}
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap items-center justify-between">
                <div class="mb-4 mr-4 md:mb-0 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Inspection</h4>
                </div>
                <div class="flex flex-wrap items-center ag-grid-table-actions-right">
                    <vs-button
                        @click="refreshData"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="refresh"
                        >Refresh</vs-button
                    >
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        @click="showFilterForm = true"
                        icon="filter_list"
                        >Filter</vs-button
                    >
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more"
                            >Spreadsheets</vs-button
                        >
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="$refs.file.click()"
                                >Import Excel</vs-dropdown-item
                            >
                            <input
                                type="file"
                                ref="file"
                                accept=".xlsx,.xls"
                                style="display: none"
                                @change="importExcel"
                            />
                            <vs-dropdown-item @click="exportInspection"
                                >Export Excel</vs-dropdown-item
                            >
                            <vs-dropdown-item @click="downloadTemplate"
                                >Download Template</vs-dropdown-item
                            >
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>

            <ag-grid-vue
                :gridOptions="gridOptions"
                class="my-4 ag-theme-material w-100 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                @cell-clicked="onCellClicked"
                @row-double-clicked="onRowDoubleClicked"
                @grid-ready="onGridReady"
            ></ag-grid-vue>
            <p class="text-right">
                <b
                    >Showing {{ dataFrom }} to {{ dataTo }} of
                    {{ dataTotal }} total entries</b
                >
            </p>
            <vs-pagination
                :total="totalPage"
                v-model="currentPage"
                :max="7"
            ></vs-pagination>

            <!-- Form filter data -->
            <vs-prompt
                buttons-hidden
                title="Filter"
                :active.sync="showFilterForm"
            >
                <div class="con-exemple-prompt">
                    <label class="vs-input--label">Tanggal Inspeksi</label>
                    <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                        <vs-col
                            vs-type="flex"
                            vs-justify="flex-start"
                            vs-align="center"
                            vs-w="5"
                            style="padding-left: 0"
                        >
                            <flat-pickr
                                class="w-full p-2 vx-col"
                                v-model="filter.start_date"
                                :config="{ dateFormat: 'Y-m-d', placeholder: 'Dari' }"
                            />
                        </vs-col>
                        <vs-col
                            vs-type="flex"
                            vs-justify="flex-start"
                            vs-align="center"
                            vs-w="2"
                            >To</vs-col
                        >
                        <vs-col
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="center"
                            vs-w="5"
                            style="padding-right: 0"
                        >
                            <flat-pickr
                                class="w-full p-2 vx-col"
                                v-model="filter.end_date"
                                :config="{ dateFormat: 'Y-m-d', placeholder: 'Sampai' }"
                            />
                        </vs-col>
                    </vs-row>

                    <label class="vs-input--label">Warehouse</label>
                    <vs-select
                        v-model="filter.warehouse_code"
                        class="selectExample mb-2 w-full"
                        width="100%"
                    >
                        <vs-select-item value="" text="All Warehouse" />
                        <vs-select-item
                            v-for="warehouse in warehouses"
                            :key="warehouse.warehouse_code"
                            :value="warehouse.warehouse_code"
                            :text="warehouse.warehouse_code"
                        />
                    </vs-select>

                    <vs-row
                        vs-align="flex-start"
                        vs-type="flex"
                        vs-justify="flex-end"
                        vs-w="12"
                        class="mt-5"
                    >
                        <vs-button
                            color="danger"
                            type="border"
                            class="mr-2"
                            @click="resetFilter"
                            >Reset</vs-button
                        >
                        <vs-button color="primary" @click="filterData"
                            >Search</vs-button
                        >
                    </vs-row>
                </div>
            </vs-prompt>
        </vx-card>

        <inspection-detail-modal
            :active.sync="showDetail"
            :inspection="selectedInspection"
            @item-deleted="onItemDeleted"
        />
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

import InspectionDetailModal from "./components/InspectionDetailModal.vue";
import { renderDeleteButton, renderExportButton, findActionTarget } from "./components/actionCell";
import "./components/actionCell.css";

const DEFAULT_FILTER = {
    fetchCount: 0,
    start_date: null,
    end_date: null,
    warehouse_code: "",
};

export default {
    components: {
        AgGridVue,
        flatPickr,
        InspectionDetailModal,
    },
    data() {
        return {
            isLoading: false,
            data: [],
            warehouses: [],
            filter: { ...DEFAULT_FILTER },
            showFilterForm: false,
            showDetail: false,
            selectedInspection: null,
            gridOptions: {},
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
            },
            columnDefs: [
                { headerName: "ID Inspeksi", field: "inspection_id", width: 150 },
                { headerName: "Tanggal Inspeksi", field: "inspection_date", width: 150 },
                { headerName: "Warehouse", field: "warehouse_code", width: 140 },
                { headerName: "Product Code", field: "product_code", width: 150 },
                { headerName: "Quantity", field: "quantity", width: 110, type: "numericColumn" },
                {
                    headerName: "Action",
                    field: "id",
                    sortable: false,
                    width: 240,
                    cellRenderer: (params) => `
                        <div class="inspection-action-cell">
                            <button
                                class="inspection-action-btn inspection-action-btn--primary"
                                data-action="detail"
                                data-id="${params.value}"
                                title="Detail"
                            >
                                <i class="material-icons">visibility</i>
                                <span>Detail</span>
                            </button>
                            ${renderExportButton(params.value)}
                            ${renderDeleteButton(params.value)}
                        </div>
                    `,
                },
            ],
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
        };
    },
    watch: {
        isLoading(val) {
            if (val) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage() {
            this.fetchData();
        },
    },
    methods: {
        onGridReady(params) {
            params.api.sizeColumnsToFit();
        },
        refreshData() {
            this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
        },
        async fetchData() {
            this.isLoading = true;
            this.setFilter(this.filter);

            try {
                const params = { per_page: 10, page: this.currentPage };
                if (this.filter.start_date) params.start_date = this.filter.start_date;
                if (this.filter.end_date) params.end_date = this.filter.end_date;
                if (this.filter.warehouse_code) params.warehouse_code = this.filter.warehouse_code;

                const resp = await this.$http.get("tvd/inspection", { params });
                const payload = resp.data;
                payload.data = (payload.data || []).map((row) => ({
                    id: row.id,
                    inspection_id: row.code,
                    inspection_date: row.date,
                    warehouse_code: row.warehouse_code,
                    product_code: row.product_code,
                    quantity: row.qty,
                }));

                this.data = payload.data;
                this.warehouses = payload.warehouses || [];
                this.totalPage = payload.last_page;
                this.dataTotal = payload.total;
                this.dataFrom = payload.from;
                this.dataTo = payload.to;
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$vs.dialog({
                    type: "confirm",
                    color: "danger",
                    title: "Server Error",
                    text: "Try again?",
                    accept: () => {
                        this.refreshData();
                    },
                    acceptText: "Yes",
                    cancelText: "No",
                });
            }
        },
        filterData() {
            this.showFilterForm = false;
            this.refreshData();
        },
        resetFilter() {
            this.filter = { ...DEFAULT_FILTER };
            this.filterData();
        },
        onCellClicked(params) {
            const target = findActionTarget(params.event);
            if (!target) return;

            const action = target.getAttribute("data-action");
            if (action === "detail") {
                this.openDetail(params.data);
            } else if (action === "delete") {
                this.confirmDelete(params.data);
            } else if (action === "export") {
                this.exportById(params.data);
            }
        },
        onRowDoubleClicked(params) {
            if (findActionTarget(params.event)) return;
            this.openDetail(params.data);
        },
        openDetail(row) {
            this.selectedInspection = row;
            this.showDetail = true;
        },
        async exportById(row) {
            this.isLoading = true;
            try {
                const response = await this.$http.get(
                    `tvd/inspection/${row.id}/export`,
                    { responseType: "blob" }
                );
                const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = `inspection_${row.inspection_id}_${Date.now()}.csv`;
                link.click();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                this.handleError(error);
            } finally {
                this.isLoading = false;
            }
        },
        confirmDelete(row) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Konfirmasi Hapus",
                text: `Hapus inspeksi ${row.inspection_id}?`,
                acceptText: "Hapus",
                cancelText: "Batal",
                accept: () => this.deleteInspection(row),
            });
        },
        async deleteInspection(row) {
            this.isLoading = true;
            try {
                const resp = await this.$http.delete(`tvd/inspection/${row.id}`);
                this.isLoading = false;
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: resp.data.message,
                });
                this.refreshAfterDelete();
            } catch (error) {
                this.isLoading = false;
                if (error && error.response) {
                    this.handleError(error);
                    return;
                }
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: (error && error.message) || "Gagal menghapus inspeksi.",
                });
            }
        },
        refreshAfterDelete() {
            // Kalau halaman aktif jadi kosong setelah hapus, mundur satu halaman.
            const isLastRowOnPage = this.data.length === 1 && this.currentPage > 1;
            if (isLastRowOnPage) {
                this.currentPage -= 1;
                return;
            }
            this.fetchData();
        },
        onItemDeleted({ inspection, quantity }) {
            // Sinkronkan Quantity header di table + modal tanpa refetch penuh.
            const row = this.data.find((item) => item.id === inspection.id);
            if (row) {
                row.quantity = quantity;
                if (this.gridOptions.api) {
                    this.gridOptions.api.refreshCells({ force: true });
                }
            }
        },
        importExcel(event) {
            const file = event.target.files && event.target.files[0];
            if (!file) return;

            const formData = new FormData();
            formData.append("file", file);
            this.isLoading = true;
            this.$http
                .post("tvd/inspection/upload", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((response) => {
                    const resp = response.data;
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: resp.message || "Upload berhasil.",
                    });
                    this.refreshData();
                })
                .catch((error) => this.handleUploadError(error))
                .finally(() => {
                    this.isLoading = false;
                    event.target.value = "";
                });
        },
        handleUploadError(error) {
            const response = error && error.response && error.response.data;
            const errors = response && (response.errors || response.message);

            if (Array.isArray(errors) && errors.length) {
                errors.forEach((item) => {
                    const row = item && item.row ? `Baris ${item.row}: ` : "";
                    const message = item && item.message ? item.message : String(item);

                    this.$vs.notify({
                        color: "danger",
                        title: "Upload gagal",
                        text: `${row}${message}`,
                        time: 10000,
                    });
                });
                return;
            }

            this.handleError(error);
        },
        exportInspection() {
            this.isLoading = true;
            this.$http
                .get("tvd/inspection/export", {
                    params: {
                        start_date: this.filter.start_date,
                        end_date: this.filter.end_date,
                        warehouse_code: this.filter.warehouse_code,
                    },
                    responseType: "blob",
                })
                .then((resp) => {
                    const blob = new Blob([resp.data], { type: "text/csv;charset=utf-8" });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `inspection_export_${Date.now()}.csv`;
                    link.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => this.handleError(error))
                .finally(() => {
                    this.isLoading = false;
                });
        },
        downloadTemplate() {
            this.isLoading = true;
            this.$http
                .get("tvd/inspection/template", { responseType: "blob" })
                .then((resp) => {
                    const blob = new Blob([resp.data]);
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `inspection_template_${Date.now()}.xlsx`;
                    link.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => this.handleError(error))
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
    mounted() {
        this.fetchData();
    },
    beforeMount() {
        const filter = this.getFilter();

        if (filter) {
            this.filter = { ...DEFAULT_FILTER, ...filter, fetchCount: 0 };
        }

        this.gridOptions.getRowHeight = function () {
            return 35;
        };

        this.gridOptions.suppressRowClickSelection = true;
        this.gridOptions.suppressCellSelection = true;
    },
};
</script>
